import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Category } from "@modules/categorys/types/category";
import { ListCategorysQueryFilters } from "./types";

export async function getCategorysService(filters?: ListCategorysQueryFilters): Promise<Category[]> {
  try {
    const { data } = await api.get<ApiResponse<Category>>(`v1/category_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        ordering: "-id",
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching categorys:", error);
    throw error;
  }
}
